import { useEffect, useState } from 'react';
import axios from "axios";
import { useHistory} from 'react-router-dom'
import CHeader from '../../app-components/CHeader';
import { FiChevronDown } from "react-icons/fi";
import { BsThreeDotsVertical } from "react-icons/bs";
import { BiPhoneCall } from "react-icons/bi";
import { RiWhatsappLine } from "react-icons/ri";
import { GoMail } from "react-icons/go";
import { IoChevronForwardOutline } from "react-icons/io5";
import CFooter from '../../app-components/CFooter';
import { globleAPI as Global } from '../../globals'



function Purchases(props: any) {

    const [token] = useState(localStorage.getItem('token') || '')
    const [purchaseHistroy, setpurchaseHistroy] = useState<any>([])
    const [Offer, setOffer] = useState<any>(false)
    const [purchse, setpurchse] = useState<any>(true)
    const history = useHistory();

    useEffect(() => {
        window.scrollTo(0, 0)
        axios
            .get(Global.PURCHASE_HISTORY + token)
            .then(response => {
                setpurchaseHistroy(response.data.my_orders)
            })
            .catch(function (error) {
                console.log('response if the api is errror =', error)
            });
    }, [])

    const move = (data: any) => {
        if (data == 'offer') {
            setpurchse(false)
            setOffer(true)
        } else {
            setpurchse(true)
            setOffer(false)
        }
    }

    const gotoShopAll = () => {
        history.push('/',);
    };

    const movetoDetail = (data: any) => {
        history.push('/order-detail', [data]);
    };

    return (
        <div>
            <CHeader></CHeader>
            <div className="page-left-padding page-right-padding bg-color-light"  >
                <div className="page-left-padding page-right-padding cm-l-25 cm-r-25 cp-t-40 cp-b-20"   >
                    <label className="label secHeading primary-color" >My Purchases</label>
                    <div className="d-flex" >
                        <label onClick={() => gotoShopAll()} className=" hoverUnderLine touchAble label labelText cp-r-35 cp-t-10 cp-b-10 "  >Buy</label>
                        <label onClick={() => move('pruchase')} className="label labelText cp-r-35 cp-t-10 cp-b-10 hoverUnderLine touchAble "  >Purchase History</label>
                        <label onClick={() => move('offer')} className="label labelText cp-r-35 cp-t-10 cp-b-10 hoverUnderLine touchAble "  >Price Offer Request</label>
                    </div>
                    {Offer == true && <div>
                        <div>
                            <div className=' border-top cp-t-20 cp-b-20' >
                                <div className='d-flex flex-row' >
                                    <div className='d-flex flex-row col-6'>
                                        <div className='d-flex flex-column cp-l-10 ' >
                                            <label className='labelText label primary-color   '   >bag</label>
                                            <label className='pText  label '  >New</label>
                                            <label className='pText label'  >gucci</label>
                                        </div>
                                    </div>
                                    <div className='col-4 d-flex justify-content-end  ' >
                                        <div className='d-flex flex-column' >
                                            <div>
                                                <label className='d-flex justify-content-center f-14 line-through'  >AED 100</label>
                                                <label className='d-flex justify-content-center f-15 f-500 primary-color'  >AED 200</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                    {purchse == true &&
                        <div>
                            <label className="label secHeading primary-color cp-t-30 " >Purchase History</label>
                            <div className="d-flex justify-content-end cp-b-10" >
                                <label className="label labelText text-muted primary-color cp-7 cp-r-10  " >Sort Orders   </label>
                                <label className="label pText text-muted primary-color cp-t-8  cp-l-10 cp-r-2 " style={{ backgroundColor: 'white' }} >By Date <label className="cp-l-20" >  <FiChevronDown size='20' className=" border-left cp-l-5" /></label></label>
                            </div>
                            {purchaseHistroy.length ? (
                                <div className="cm-b-40 cp-b-40"   >
                                    {
                                        purchaseHistroy.map((data1: any) =>
                                            <div className="cm-b-40 " style={{ backgroundColor: 'white' }} >
                                                <div className="d-flex col-12 justify-content-between c-border-bottom cp-b-10 " style={{borderColor:'gray' ,borderWidth:2}} >
                                                    <div className="d-flex flex-column" >
                                                        <label className="label pText text-muted primary-color font-weight-bold cp-t-10 " > <label className="label font-weight-bold" >Order ID:</label> {data1.id}</label>
                                                        <label className="label pText text-muted primary-color  font-weight-bold  "  > <label className="label font-weight-bold" >Date Ordered:</label>  {data1.order_date?.substring(0, 10)} </label>
                                                    </div>
                                                    <div className=" cp-t-10" >
                                                     {data1.status !== 'Canceled' &&  <a className="label labelText   cp-t-6 cp-b-6 cp-l-10 cp-r-10  bg-color-primary " style={{ color: 'white' }} href="https://my.ccs-uae.com/track">Track Order</a> }  
                                                        <BsThreeDotsVertical size="25" />
                                                    </div>
                                                </div>
                                                <div className="d-flex flex-row   overflow-auto  col-md-12 " >
                                                    <div className="d-flex flex-row col-11 " >
                                                        {purchaseHistroy.map((data2: any) =>
                                                            <div className="d-flex flex-row  overflow-auto"  >
                                                                {data2.id == data1.id && (
                                                                    <div className='d-flex flex-row cp-t-30   cp-r-10' style={{ backgroundColor: 'white' }}>
                                                                        <div className='d-flex flex-row justify-content-between ' >
                                                                            <div className='d-flex flex-row' >
                                                                                <img className='carosal-image-Web' style={{ height: 90, width: 90 }} src={'https://lesfemmestesting.dominioninc.org/public/uploads/images/' + data2.image} alt="First slide" />
                                                                                <div className='d-flex flex-column cp-l-10 ' >
                                                                                    <label className=' labelHeading label primary-color  main-font'   >{data2.name}</label>
                                                                                    <label className='pText f-600  label main-font text-muted'  >{data2.manufacturer_name}</label>
                                                                                    <label className=' labelHeading font-weight-bold cp-t-15 label main-font'  >{data2.status}</label>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="col-1 d-flex flex-row-reverse touchAble cp-t-15" onClick={() => movetoDetail(data1.id)} ><IoChevronForwardOutline size="38" color="lightgray" /></div>
                                                </div>
                                                <div className="d-flex justify-content-between cp-30" >
                                                    {data1.status == 'Delivered' &&
                                                        <label className="label labelText   cp-t-3 cp-b-3 cp-l-10 cp-r-10  bg-color-primary  touchAble" onClick={() => movetoDetail(data1.id)} style={{ color: 'white' }} >Review This Order</label>
                                                    }
                                                    <label></label>
                                                    <label className=' pText font-weight-bold cp-t-10 label main-font text-muted '  >2 days ago</label>
                                                </div>
                                            </div>
                                        )}
                                </div>
                            ) : null}
                        </div>
                    }
                </div>
            </div>
            <div className='d-flex justify-content-start padding  cp-t-10 cp-b-7  flex-row align-items-center' style={{ backgroundColor: 'white' }} >
                <label className=' text-uppercase f-14 font-weight-bold  label cp-l-5 cp-r-15  main-font'>Need help?</label>
                <div className=" d-flex flex-row" >
                    <div className="d-flex  justify-content-center align-self-center " >
                        <a className='label  f-13   cp-r-15 main-font ' style={{ color: 'black' }} target="_blank" href="tel:+971588241922"><BiPhoneCall size='17' />Call us</a>
                    </div>
                    <div className="d-flex justify-content-center align-self-center" >
                        <a className='label  f-13   cp-r-15 main-font ' style={{ color: 'black' }} target="_blank" href="https://api.whatsapp.com/send/?phone=971588241922&text&app_absent=0"><RiWhatsappLine size='17' />WhatsApp</a>
                    </div>
                    <div className="d-flex justify-content-center align-self-center" >
                        <a className='label  f-13   cp-r-15 main-font ' style={{ color: 'black' }} target="_blank" href="mailto:support@lesfemmes.net"><GoMail size='17' /> Email</a>
                    </div>
                </div>
            </div>
            <CFooter />
        </div>
    );
}

export default Purchases;
